import React, { useState, useEffect } from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Stats from "./components/Stats";
import Partners from "./components/Partners";
import FeaturedListings from "./components/FeaturedListings";
import AboutUs from "./components/AboutUs";
import Services from "./components/Services";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import EnquireModal from "./components/EnquireModal";
import ProjectDetail from "./components/ProjectDetail";

const defaultEnquiryContext = {
  source: "Website Enquiry",
  property: "General Enquiry",
};

function App() {
  const [enquireOpen, setEnquireOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [activeProject, setActiveProject] = useState(null);
  const [enquiryContext, setEnquiryContext] = useState(defaultEnquiryContext);

  // Show popup after 15 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      const dismissed = sessionStorage.getItem('popup_dismissed');
      if (!dismissed) {
        setEnquiryContext({
          source: 'Timed Popup',
          property: 'General Enquiry',
        });
        setShowPopup(true);
      }
    }, 15000);
    return () => clearTimeout(timer);
  }, []);

  const handleClosePopup = () => {
    setShowPopup(false);
    sessionStorage.setItem('popup_dismissed', 'true');
  };

  const handleViewProject = (projectId) => {
    setActiveProject(projectId);
  };

  const openEnquiry = (context = {}) => {
    setEnquiryContext({
      ...defaultEnquiryContext,
      ...context,
      source: context.source || defaultEnquiryContext.source,
      property: context.property || defaultEnquiryContext.property,
    });
    setEnquireOpen(true);
  };

  return (
    <div className="App bg-[#0a0a0a] min-h-screen">
      <Navbar onEnquireClick={() => openEnquiry({ source: 'Navbar CTA' })} />
      <Hero onEnquireClick={() => openEnquiry({ source: 'Hero CTA' })} />
      <Stats />
      <Partners />
      <FeaturedListings onViewProject={handleViewProject} />
      <AboutUs onEnquireClick={() => openEnquiry({ source: 'About Us CTA' })} />
      <Services />
      <Testimonials />
      <Contact />
      <Footer />

      {/* Enquire Modal */}
      <EnquireModal
        isOpen={enquireOpen || showPopup}
        context={showPopup ? { source: 'Timed Popup', property: 'General Enquiry' } : enquiryContext}
        onClose={() => {
          setEnquireOpen(false);
          if (showPopup) handleClosePopup();
        }}
      />

      {/* Project Detail Modal */}
      <ProjectDetail
        projectId={activeProject}
        isOpen={!!activeProject}
        onClose={() => setActiveProject(null)}
        onEnquire={(project) => {
          setActiveProject(null);
          openEnquiry({
            source: 'Project Detail',
            property: project?.name || 'General Enquiry',
          });
        }}
      />
    </div>
  );
}

export default App;
